var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTagsManagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_tags_management_svg__clip0_7022_32055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.106 12.756l-9.053-9.053a1.28 1.28 0 00-.914-.367h-1.393l10.42 10.3-7.02 7.08a1.285 1.285 0 001.82 0l6.14-6.14a1.285 1.285 0 000-1.82z",
    fill: "#393E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.52 12.783l-9.054-9.06a1.28 1.28 0 00-.914-.387H2.406a1.287 1.287 0 00-1.287 1.287v6.146a1.28 1.28 0 00.38.907l9.06 9.06a1.286 1.286 0 001.82 0l6.14-6.14a1.286 1.286 0 000-1.813zM4.445 7.816a1.153 1.153 0 110-2.307 1.153 1.153 0 010 2.307z",
    fill: "#393E4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_tags_management_svg__clip0_7022_32055"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

export default SvgIconTagsManagement;